import { ColorWheelInterface, ColorInterface } from './types/types';

export const colorWheel: Array<ColorWheelInterface> = [
  {
    colorName: 'Maize',
    colorCode: '#FFFCE9',
    textColor: 'black',
  },
  {
    colorName: 'Cream',
    colorCode: '#FFF0DD',
    textColor: 'black',
  },
  {
    colorName: 'Antique',
    colorCode: '#D9D6CD',
    textColor: 'black',
  },
  {
    colorName: 'White',
    colorCode: '#FFFFFF',
    textColor: 'black',
  },
  {
    colorName: 'Moon',
    colorCode: '#D8D6D7',
    textColor: 'black',
  },
  {
    colorName: 'Ice',
    colorCode: '#F1F3FF',
    textColor: 'black',
  },
  {
    colorName: 'Orca',
    colorCode: '#E2DFFD',
    textColor: 'black',
  },
  {
    colorName: 'Platinum',
    colorCode: '#C8BDCE',
    textColor: 'black',
  },
  {
    colorName: 'Silver',
    colorCode: '#BCBBC0',
    textColor: 'black',
  },
  {
    colorName: 'Dust',
    colorCode: '#9C9C9E',
    textColor: 'white',
  },
  {
    colorName: 'Grey',
    colorCode: '#7F7F7F',
    textColor: 'white',
  },
  {
    colorName: 'Smoke',
    colorCode: '#9495AA',
    textColor: 'white',
  },
  {
    colorName: 'Gloom',
    colorCode: '#545365',
    textColor: 'white',
  },
  {
    colorName: 'Lead',
    colorCode: '#403C3E',
    textColor: 'white',
  },
  {
    colorName: 'Shale',
    colorCode: '#4D484F',
    textColor: 'white',
  },
  {
    colorName: 'Flint',
    colorCode: '#636268',
    textColor: 'white',
  },
  {
    colorName: 'Charcoal',
    colorCode: '#545454',
    textColor: 'white',
  },
  {
    colorName: 'Coal',
    colorCode: '#4A4945',
    textColor: 'white',
  },
  {
    colorName: 'Oilslick',
    colorCode: '#342B26',
    textColor: 'white',
  },
  {
    colorName: 'Black',
    colorCode: '#333333',
    textColor: 'white',
  },
  {
    colorName: 'Obsidian',
    colorCode: '#1D2225',
    textColor: 'white',
  },
  {
    colorName: 'Eldritch',
    colorCode: '#252A24',
    textColor: 'white',
  },
  {
    colorName: 'Midnight',
    colorCode: '#292B38',
    textColor: 'white',
  },
  {
    colorName: 'Shadow',
    colorCode: '#3A2E44',
    textColor: 'white',
  },
  {
    colorName: 'Blackberry',
    colorCode: '#4C2A4F',
    textColor: 'white',
  },
  {
    colorName: 'Mulberry',
    colorCode: '#6E235C',
    textColor: 'white',
  },
  {
    colorName: 'Plum',
    colorCode: '#863290',
    textColor: 'white',
  },
  {
    colorName: 'Wisteria',
    colorCode: '#714D79',
    textColor: 'white',
  },
  {
    colorName: 'Thistle',
    colorCode: '#8E7C8A',
    textColor: 'white',
  },
  {
    colorName: 'Fog',
    colorCode: '#A592B0',
    textColor: 'white',
  },
  {
    colorName: 'Mist',
    colorCode: '#E1CDFE',
    textColor: 'black',
  },
  {
    colorName: 'Lavender',
    colorCode: '#CCA4E0',
    textColor: 'black',
  },
  {
    colorName: 'Heather',
    colorCode: '#9678BB',
    textColor: 'white',
  },
  {
    colorName: 'Purple',
    colorCode: '#A260CE',
    textColor: 'white',
  },
  {
    colorName: 'Orchid',
    colorCode: '#D950FF',
    textColor: 'white',
  },
  {
    colorName: 'Amethyst',
    colorCode: '#993BD1',
    textColor: 'white',
  },
  {
    colorName: 'Nightshade',
    colorCode: '#772EB3',
    textColor: 'white',
  },
  {
    colorName: 'Violet',
    colorCode: '#643F9C',
    textColor: 'white',
  },
  {
    colorName: 'Grape',
    colorCode: '#580EC0',
    textColor: 'white',
  },
  {
    colorName: 'Royal',
    colorCode: '#4E2C8A',
    textColor: 'white',
  },
  {
    colorName: 'Eggplant',
    colorCode: '#3F2B66',
    textColor: 'white',
  },
  {
    colorName: 'Iris',
    colorCode: '#525195',
    textColor: 'white',
  },
  {
    colorName: 'Storm',
    colorCode: '#757ADA',
    textColor: 'white',
  },
  {
    colorName: 'Twilight',
    colorCode: '#484AA1',
    textColor: 'white',
  },
  {
    colorName: 'Indigo',
    colorCode: '#2D237A',
    textColor: 'white',
  },
  {
    colorName: 'Sapphire',
    colorCode: '#0D0A5B',
    textColor: 'white',
  },
  {
    colorName: 'Navy',
    colorCode: '#212B60',
    textColor: 'white',
  },
  {
    colorName: 'Cobalt',
    colorCode: '#003384',
    textColor: 'white',
  },
  {
    colorName: 'Ultramarine',
    colorCode: '#1B51E7',
    textColor: 'white',
  },
  {
    colorName: 'Blue',
    colorCode: '#314BA7',
    textColor: 'white',
  },
  {
    colorName: 'Periwinkle',
    colorCode: '#4866D4',
    textColor: 'white',
  },
  {
    colorName: 'Lapis',
    colorCode: '#2C84FF',
    textColor: 'white',
  },
  {
    colorName: 'Splash',
    colorCode: '#6494DC',
    textColor: 'white',
  },
  {
    colorName: 'Cornflower',
    colorCode: '#75A8FF',
    textColor: 'white',
  },
  {
    colorName: 'Sky',
    colorCode: '#AFC8FD',
    textColor: 'black',
  },
  {
    colorName: 'Stonewash',
    colorCode: '#7895C1',
    textColor: 'black',
  },
  {
    colorName: 'Overcast',
    colorCode: '#454F6A',
    textColor: 'white',
  },
  {
    colorName: 'Steel',
    colorCode: '#56697A',
    textColor: 'white',
  },
  {
    colorName: 'Denim',
    colorCode: '#304558',
    textColor: 'white',
  },
  {
    colorName: 'Abyss',
    colorCode: '#0C1D24',
    textColor: 'white',
  },
  {
    colorName: 'Phthalo',
    colorCode: '#0B2D46',
    textColor: 'white',
  },
  {
    colorName: 'Azure',
    colorCode: '#0A3D68',
    textColor: 'white',
  },
  {
    colorName: 'Caribbean',
    colorCode: '#0186CE',
    textColor: 'white',
  },
  {
    colorName: 'Teal',
    colorCode: '#2C768F',
    textColor: 'white',
  },
  {
    colorName: 'Cerulean',
    colorCode: '#00B4D5',
    textColor: 'white',
  },
  {
    colorName: 'Cyan',
    colorCode: '#01FFF1',
    textColor: 'white',
  },
  {
    colorName: 'Robin',
    colorCode: '#9BEAEF',
    textColor: 'black',
  },
  {
    colorName: 'Aqua',
    colorCode: '#73C4C5',
    textColor: 'black',
  },
  {
    colorName: 'Turquoise',
    colorCode: '#39A0A3',
    textColor: 'black',
  },
  {
    colorName: 'Spruce',
    colorCode: '#8BBAB2',
    textColor: 'black',
  },
  {
    colorName: 'Pistachio',
    colorCode: '#E3FFE8',
    textColor: 'black',
  },
  {
    colorName: 'Seafoam',
    colorCode: '#B2E1BD',
    textColor: 'black',
  },
  {
    colorName: 'Mint',
    colorCode: '#9BFEC5',
    textColor: 'black',
  },
  {
    colorName: 'Jade',
    colorCode: '#61AB8A',
    textColor: 'black',
  },
  {
    colorName: 'Spearmint',
    colorCode: '#148E67',
    textColor: 'black',
  },
  {
    colorName: 'Thicket',
    colorCode: '#005D48',
    textColor: 'white',
  },
  {
    colorName: 'Peacock',
    colorCode: '#1E4739',
    textColor: 'white',
  },
  {
    colorName: 'Emerald',
    colorCode: '#20603E',
    textColor: 'white',
  },
  {
    colorName: 'Shamrock',
    colorCode: '#236825',
    textColor: 'white',
  },
  {
    colorName: 'Jungle',
    colorCode: '#1F361A',
    textColor: 'white',
  },
  {
    colorName: 'Hunter',
    colorCode: '#1E2716',
    textColor: 'white',
  },
  {
    colorName: 'Forest',
    colorCode: '#414F35',
    textColor: 'white',
  },
  {
    colorName: 'Camo',
    colorCode: '#51684C',
    textColor: 'white',
  },
  {
    colorName: 'Algae',
    colorCode: '#97AF8B',
    textColor: 'black',
  },
  {
    colorName: 'Swamp',
    colorCode: '#687E67',
    textColor: 'black',
  },
  {
    colorName: 'Avocado',
    colorCode: '#587B35',
    textColor: 'black',
  },
  {
    colorName: 'Green',
    colorCode: '#609E3C',
    textColor: 'black',
  },
  {
    colorName: 'Fern',
    colorCode: '#7FCE73',
    textColor: 'black',
  },
  {
    colorName: 'Mantis',
    colorCode: '#99FE9C',
    textColor: 'black',
  },
  {
    colorName: 'Pear',
    colorCode: '#8ECE55',
    textColor: 'black',
  },
  {
    colorName: 'Leaf',
    colorCode: '#A6E130',
    textColor: 'black',
  },
  {
    colorName: 'Radioactive',
    colorCode: '#C6FF00',
    textColor: 'black',
  },
  {
    colorName: 'Honeydew',
    colorCode: '#D2E673',
    textColor: 'black',
  },
  {
    colorName: 'Peridot',
    colorCode: '#EAFFB6',
    textColor: 'black',
  },
  {
    colorName: 'Charteuse',
    colorCode: '#B4CD3D',
    textColor: 'black',
  },
  {
    colorName: 'Spring',
    colorCode: '#AA9F33',
    textColor: 'white',
  },
  {
    colorName: 'Crocodile',
    colorCode: '#828335',
    textColor: 'black',
  },
  {
    colorName: 'Olive',
    colorCode: '#697135',
    textColor: 'white',
  },
  {
    colorName: 'Murk',
    colorCode: '#4C4420',
    textColor: 'black',
  },
  {
    colorName: 'Moss',
    colorCode: '#7E7645',
    textColor: 'black',
  },
  {
    colorName: 'Goldenrod',
    colorCode: '#BEA65E',
    textColor: 'white',
  },
  {
    colorName: 'Amber',
    colorCode: '#C28F19',
    textColor: 'black',
  },
    {
    colorName: 'Honey',
    colorCode: '#D2B301',
    textColor: 'black',
  },
  {
    colorName: 'Lemon',
    colorCode: '#FFE53C',
    textColor: 'black',
  },
  {
    colorName: 'Yellow',
    colorCode: '#F8E155',
    textColor: 'black',
  },
  {
    colorName: 'Grapefruit',
    colorCode: '#F7FF6E',
    textColor: 'black',
  },
  {
    colorName: 'Banana',
    colorCode: '#FEEC80',
    textColor: 'black',
  },
  {
    colorName: 'Sanddollar',
    colorCode: '#EBE6AE',
    textColor: 'black',
  },
  {
    colorName: 'Flaxen',
    colorCode: '#FDE9AE',
    textColor: 'black',
  },
  {
    colorName: 'Ivory',
    colorCode: '#FFD298',
    textColor: 'black',
  },
  {
    colorName: 'Buttercup',
    colorCode: '#F6BF6C',
    textColor: 'black',
  },
  {
    colorName: 'Gold',
    colorCode: '#E8AE4A',
    textColor: 'black',
  },
  {
    colorName: 'Metals',
    colorCode: '#D1B146',
    textColor: 'black',
  },
  {
    colorName: 'Marigold',
    colorCode: '#FEB43B',
    textColor: 'black',
  },
  {
    colorName: 'Sunshine',
    colorCode: '#FB912B',
    textColor: 'white',
  },
  {
    colorName: 'Saffron',
    colorCode: '#FE8501',
    textColor: 'white',
  },
  {
    colorName: 'Sunset',
    colorCode: '#FFA247',
    textColor: 'white',
  },
  {
    colorName: 'Peach',
    colorCode: '#FFB576',
    textColor: 'black',
  },
  {
    colorName: 'Cantaloupe',
    colorCode: '#FF984F',
    textColor: 'black',
  },
  {
    colorName: 'Orange',
    colorCode: '#D5602B',
    textColor: 'white',
  },
  {
    colorName: 'Bronze',
    colorCode: '#B1560D',
    textColor: 'white',
  },
  {
    colorName: 'Terracotta',
    colorCode: '#B24407',
    textColor: 'white',
  },
  {
    colorName: 'Carrot',
    colorCode: '#FF5500',
    textColor: 'white',
  },
  {
    colorName: 'Fire',
    colorCode: '#EF5D24',
    textColor: 'white',
  },
  {
    colorName: 'Pumpkin',
    colorCode: '#FF6841',
    textColor: 'white',
  },
  {
    colorName: 'Tangerine',
    colorCode: '#FF7361',
    textColor: 'white',
  },
  {
    colorName: 'Cinnamon',
    colorCode: '#C15A39',
    textColor: 'white',
  },
  {
    colorName: 'Caramel',
    colorCode: '#C57047',
    textColor: 'white',
  },
  {
    colorName: 'Sand',
    colorCode: '#B17749',
    textColor: 'white',
  },
  {
    colorName: 'Tan',
    colorCode: '#C59A70',
    textColor: 'white',
  },
  {
    colorName: 'Beige',
    colorCode: '#CBBBA1',
    textColor: 'white',
  },
  {
    colorName: 'Stone',
    colorCode: '#817964',
    textColor: 'white',
  },
  {
    colorName: 'Taupe',
    colorCode: '#6E665B',
    textColor: 'white',
  },
  {
    colorName: 'Slate',
    colorCode: '#564D48',
    textColor: 'white',
  },
  {
    colorName: 'Driftwood',
    colorCode: '#76645A',
    textColor: 'white',
  },
  {
    colorName: 'Latte',
    colorCode: '#977B6D',
    textColor: 'white',
  },
  {
    colorName: 'Dirt',
    colorCode: '#774840',
    textColor: 'white',
  },
  {
    colorName: 'Clay',
    colorCode: '#613F3E',
    textColor: 'white',
  },
  {
    colorName: 'Sable',
    colorCode: '#58382D',
    textColor: 'white',
  },
  {
    colorName: 'Umber',
    colorCode: '#301E1A',
    textColor: 'white',
  },
  {
    colorName: 'Soil',
    colorCode: '#5A4534',
    textColor: 'white',
  },
  {
    colorName: 'Hickory',
    colorCode: '#715538',
    textColor: 'white',
  },
  {
    colorName: 'Tarnish',
    colorCode: '#865C32',
    textColor: 'white',
  },
  {
    colorName: 'Ginger',
    colorCode: '#8F542C',
    textColor: 'white',
  },
  {
    colorName: 'Brown',
    colorCode: '#8E5B40',
    textColor: 'white',
  },
  {
    colorName: 'Chocolate',
    colorCode: '#573013',
    textColor: 'white',
  },
  {
    colorName: 'Auburn',
    colorCode: '#7B3C1D',
    textColor: 'white',
  },
  {
    colorName: 'Copper',
    colorCode: '#A44B29',
    textColor: 'white',
  },
  {
    colorName: 'Rust',
    colorCode: '#8B3220',
    textColor: 'white',
  },
  {
    colorName: 'Tomato',
    colorCode: '#B9311B',
    textColor: 'white',
  },
  {
    colorName: 'Vermillion',
    colorCode: '#E22D18',
    textColor: 'white',
  },
  {
    colorName: 'Ruby',
    colorCode: '#CD000F',
    textColor: 'white',
  },
  {
    colorName: 'Cherry',
    colorCode: '#AA0024',
    textColor: 'white',
  },
  {
    colorName: 'Crimson',
    colorCode: '#850013',
    textColor: 'white',
  },
  {
    colorName: 'Garnet',
    colorCode: '#5B0E14',
    textColor: 'white',
  },
  {
    colorName: 'Sanguine',
    colorCode: '#2E0002',
    textColor: 'white',
  },
  {
    colorName: 'Blood',
    colorCode: '#451717',
    textColor: 'white',
  },
  {
    colorName: 'Maroon',
    colorCode: '#662028',
    textColor: 'white',
  },
  {
    colorName: 'Berry',
    colorCode: '#8D262D',
    textColor: 'white',
  },
  {
    colorName: 'Red',
    colorCode: '#C1262D',
    textColor: 'white',
  },
  {
    colorName: 'Strawberry',
    colorCode: '#DF3236',
    textColor: 'white',
  },
  {
    colorName: 'Cerise',
    colorCode: '#A22A2B',
    textColor: 'white',
  },
  {
    colorName: 'Carmine',
    colorCode: '#B13B3B',
    textColor: 'white',
  },
  {
    colorName: 'Brick',
    colorCode: '#9A534D',
    textColor: 'white',
  },
  {
    colorName: 'Coral',
    colorCode: '#CC706F',
    textColor: 'white',
  },
  {
    colorName: 'Blush',
    colorCode: '#FFA2A2',
    textColor: 'white',
  },
  {
    colorName: 'Cottoncandy',
    colorCode: '#EC7896',
    textColor: 'white',
  },
  {
    colorName: 'Watermelon',
    colorCode: '#DC528B',
    textColor: 'white',
  },
  {
    colorName: 'Magenta',
    colorCode: '#EA34AB',
    textColor: 'white',
  },
  {
    colorName: 'Fushia',
    colorCode: '#EC0089',
    textColor: 'white',
  },
  {
    colorName: 'Raspberry',
    colorCode: '#8A024B',
    textColor: 'white',
  },
  {
    colorName: 'Wine',
    colorCode: '#4D0F28',
    textColor: 'white',
  },
  {
    colorName: 'Mauve',
    colorCode: '#9B4874',
    textColor: 'white',
  },
  {
    colorName: 'Pink',
    colorCode: '#E77EC0',
    textColor: 'white',
  },
  {
    colorName: 'Bubblegum',
    colorCode: '#E7A9FF',
    textColor: 'black',
  },
  {
    colorName: 'Rose',
    colorCode: '#FED7F6',
    textColor: 'black',
  },
  {
    colorName: 'Pearl',
    colorCode: '#FBEDFA',
    textColor: 'white',
  },
];

// gets color interface from wheel when given an index
export const getColor = (index: number): ColorInterface => {
  if (index < 0 || index > colorWheel.length - 1) {
    return {
      colorName: '',
      colorCode: '',
      textColor: '',
      value: -1,
    }
  }
  
 return {...colorWheel[index], value: index};
}

// finds the shortest distance between two colors and returns span of colors between them
export const getSpanBetweenColors = ({ value: color1 }: ColorInterface, { value: color2 }: ColorInterface): Array<ColorInterface> => {
  let currentColor: number = Math.min(color1, color2);
  let goal: number = Math.max(color1, color2);;
  let span: Array<ColorInterface> = [{...colorWheel[currentColor], value: currentColor}]; // default span is single color

  // SHORT CIRCUIT
  if (color1 > colorWheel.length || color2  > colorWheel.length || color1 < 0 || color2 < 0) {
    return [];
  }

  // FINDING THE RIGHT DISTANCE
  // if this distance is > half the length, we go around the loop
  if (Math.abs(color1 - color2) > colorWheel.length / 2) {
      // to do this, go from higher number -> lower number
      // otherwise we normally do lower number -> higher number
      currentColor = Math.max(color1, color2);
      goal = Math.min(color1, color2);
      span = [{...colorWheel[currentColor], value: currentColor}];
  }

  // MAKE SPAN OF COLORS
  // while we are not at our goal
  while (currentColor !== goal) {
    currentColor++;

    // if we went past the max color value, reset to beginning of loop
    if (currentColor > colorWheel.length - 1) {
      currentColor = 0;
    }

    span.push({...colorWheel[currentColor], value: currentColor});
  }

  return span;
}

// Alex wuz here >:)